import { apiEnvironment } from '../smoothr-web-app-core/environments/apiEnvironment';

export const environment = {
	...apiEnvironment,
	countryList: ['de'],
	customerGroup: 'topgolf',
	clarity: 'tnwdtchldo',
	applePayMerchant: 'merchant.com.adyen.de.smoothr.topgolf.test',
	googlePayMerchant: 'BCR2DN6T5OYNT6CG',
	googlePayMerchantName: 'TopGolf',
	googlePayEnvironment: 'TEST',
	applePayEnvironment: 'TEST',
	adyenEnvironment: 'test',
	socketTimeoutWhilePaymentInMins: 2,
	topgolfOrderUrl: 'https://dev-topgolf-order.smoothr.de',
	paypalUrl: 'https://sandbox.paypal.com',
	smoothrFeedbackApiUrl: 'https://n8n.greenreb.com/webhook/v2/smoothr-gaeste-rueckmeldung',
	smoothrFeedbackApiKey: 'c1b84d19bd73895a46f2c007844e7f341e294a818481d61307364df63927e0f9',
	doubleMondayId: 221, // D_MONDAY
	doubleMondayCode: 'D_MONDAY',
	deinstagId: 48, // DEINSTAG
	deinstagCode: 'DEINSTAG',
	deinstagPlus: ['80300003', '80200047'],
	studentsId: 26, // S_THURSDAY
	studentsCode: 'S_THURSDAY',
};
